import React, { Component } from "react";
import Button, { BUTTON_DISPLAY } from "@acadia-ui/button";
import Modal from "@acadia-ui/modal";
import Textbox from "@acadia-ui/textbox";

import "./duplicateModal.scss";
import Loading from "../../Components/LoadingSpinner";
import TableHelper from "../../Components/Table/TableHelper";

class DuplicatePlatformModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			cloneCount: ""
		};
	}

	handleClone = () => {
		this.setState({ loading: true }, () => {
			const platformFieldsToDelete = [
				"TraffickingWorkflowStatusID",
				"TraffickingRequestID",
				"TraffickingRequestGroupNumbers",
				"TraffickingPlacementStatusID",
				"PlatformPlacementPK",
				"PlatformPackagePK",
				"PlatformInsertionOrderPK",
				"PlatformLineItemPK",
				"ExternalSystemStatusID",
				"GoogleCampaignManagerPK"
			];
			const rowsToDupe = JSON.parse(JSON.stringify(this.props.data));
			rowsToDupe.forEach((row) => {
				row.CampaignID = null;
				row.TaxonomyData = null;
				row.CreatedBy = null;
				row.UpdatedBy = null;
				row.UniqueID = null;
				row.Row = null;
				row.isEdited = true;

				platformFieldsToDelete.forEach((fieldName) => {
					delete row[fieldName];
				});

				if (this.props.type === "Ad Set" || this.props.type === "Ad Group" || this.props.type === "AdSet") {
					delete row.AdSetID;
					delete row.AdSetName;
				}
				if (this.props.type === "Placement") {
					delete row.PlacementID;
					row.PlacementName = null;
					row.Size = null;
					row.PlacementSize = null;
					row.Dimensions = null;
					if (row.MasterPlatformID == 5) {
						row.ExternalSystemStatusID = 1;
						row.TraffickingPlacementStatusID = null;
						row.ExternalSystemResponse = "Not Synced";
					}
				}
				if (this.props.type === "Creative") {
					delete row.CreativeID;
					delete row.CreativeName;
				}
				if (this.props.type === "Line Item") {
					delete row.LineItemID;
					delete row.LineItemName;
				}
			});

			const dataWithDuplicates = TableHelper.createDuplicates(JSON.parse(JSON.stringify(this.props.allRows)), rowsToDupe, this.state.cloneCount);
			this.setState({ loading: false }, () => {
				this.props.handleDuplicate(dataWithDuplicates, this.state.cloneCount * rowsToDupe.length);
				this.closeModal();
			});
		});
	};

	closeModal = () => {
		Modal.hide(`${this.props.type}_clone_modal`);
		this.setState({ cloneCount: "" });
	};

	render() {
		return (
			<Modal
				id={`${this.props.type}_clone_modal`}
				heading={`Clone ${this.props.type}`}
				description={
					this.props.type === "Placement"
						? "Clone Placement will inherit all original details except for the dimension field, which you will need to fill out after completing this step."
						: ""
				}
				actionSetProps={{
					actionsRight: (
						<>
							<Button display={BUTTON_DISPLAY.SECONDARY} onClick={this.closeModal} data-tracking-id-alt="cancel-clone-platform">
								Cancel
							</Button>
							<Button onClick={this.handleClone} disabled={!this.state.cloneCount || this.state.cloneCount < 1} data-tracking-id-alt="confirm-clone-platform">
								Clone
							</Button>
						</>
					)
				}}
				onRequestClose={this.closeModal}
				onClick={() => {}}
			>
				{this.state.loading && <Loading className="modalLoading" />}
				<Textbox
					type={"number"}
					required={true}
					value={parseInt(this.state.cloneCount)}
					onChange={(evt, value) => {
						const formattedValue = value ? parseInt(value) : "";
						if ((formattedValue >= 0 && formattedValue <= 50) || formattedValue === "") {
							this.setState({ cloneCount: formattedValue });
						}
					}}
				>
					How many times do you want to clone? (Limit 50)
				</Textbox>
			</Modal>
		);
	}
}

export default DuplicatePlatformModal;
